<template>
  <v-container fluid class="pb-lg-16">
    <v-row>
      <MglMap
        :mapboxGl="mapbox"
        :accessToken="accessToken"
        :mapStyle="mapStyle"
        style="height: 400px; width: 100%"
        :center="addressSelected.coordinates"
        :zoom=17
        :attributionControl="false"
        :minZoom=17
        :maxZoom=20
        
      >
        <MglMarker :coordinates="addressSelected.coordinates" :scale="0">
          <MglPopup showed class="mr-lg-n10">
            <v-card>
              <div>{{  addressSelected.address }}</div>
            </v-card>
          </MglPopup>
        </MglMarker>
      </MglMap>
    </v-row>
    <v-row class="justify-center">
      <v-btn
        v-for="(address, index) in addresses"
        :key="index"
        @click="setAddress(address)"
        class="
          rounded-0
          elevation-0
          mx-1
          px-lg-16
          px-2
          px-sm-5
          py-lg-6
          text-navy text-capitalize text-lg-body-1
          font-weight-bold
        "
        :class="{
          'background-green-light text-white':
            addressSelected.coordinates === address.coordinates,
        }"
      >
        {{ address.name }}
      </v-btn>
    </v-row>
  </v-container>
</template>
<script>
import Mapbox from "mapbox-gl";
import { MglMap, MglMarker, MglPopup } from "vue-mapbox";
import AboutUsServices from "@/services/aboutUs";

export default {
  name: "Map",
  components: { MglMap, MglMarker, MglPopup },
  async created() {
    this.mapbox = Mapbox;
    this.addresses =  await AboutUsServices.general();
    this.addresses.map((item) => {
      item.coordinates = item.coordinates?.split(', ').map(coordinate => Number(coordinate))
    })
    this.setAddress(this.addresses[0]);
  },
  data() {
    return {
      accessToken:
        "pk.eyJ1IjoiZGFyaWFubnlwZWd1ZXJvIiwiYSI6ImNreHMwbm5lMDJ4OTUyb3BubmpkaHg5bTMifQ.rnZYmJKtCQo89xdlkQFifA", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/dariannypeguero/ckzcu7asl000314oeey3o8bj4", // your map style
      addressSelected: {
        name: "Santo Domingo",
        coordinates: [-69.9216327, 18.5004548],
        address: "Av Ortega y Gasset 105, Cristo Rey, Sto. Dgo., RD",
        zoom: 17,
        number: "(809)-333-4512"
      },
      addresses: null,
    };
  },
  methods: {
    setAddress(address) {
      this.addressSelected = address;
      this.$emit('addressUpdated', address);
    },
  },
};
</script>